module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-header'), _vm._v(" "), _c('nav-bread', [_c('span', [_vm._v("Goods")])]), _vm._v(" "), _c('div', {
    staticClass: "accessory-result-page accessory-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "filter-nav"
  }, [_c('span', {
    staticClass: "sortby"
  }, [_vm._v("Sort by:")]), _vm._v(" "), _c('a', {
    staticClass: "default cur",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "price",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.sortGoods
    }
  }, [_vm._v("Price "), _c('svg', {
    staticClass: "icon icon-arrow-short",
    class: {
      'sort-up': !_vm.sortFlag
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-arrow-short"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "filterby stopPop",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.showFilterTop
    }
  }, [_vm._v("Filter by")])]), _vm._v(" "), _c('div', {
    staticClass: "accessory-result"
  }, [_c('div', {
    staticClass: "filter stopPop",
    class: {
      'filterby-show': _vm.filterBy
    },
    attrs: {
      "id": "filter"
    }
  }, [_c('dl', {
    staticClass: "filter-price"
  }, [_c('dt', [_vm._v("Price:")]), _vm._v(" "), _c('dd', {
    on: {
      "click": function($event) {
        _vm.setPriceFilter('all')
      }
    }
  }, [_c('a', {
    class: {
      'cur': _vm.priceChecked == 'all'
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("All")])]), _vm._v(" "), _vm._l((_vm.priceFilter), function(price, index) {
    return _c('dd', {
      on: {
        "click": function($event) {
          _vm.setPriceFilter(index)
        }
      }
    }, [_c('a', {
      class: {
        'cur': _vm.priceChecked == index
      },
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(price.startPrice) + " - " + _vm._s(price.endPrice))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "accessory-list-wrap"
  }, [_c('div', {
    staticClass: "accessory-list col-4"
  }, [_c('ul', _vm._l((_vm.goodslist), function(item, index) {
    return _c('li', [_c('div', {
      staticClass: "pic"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: ('/static/' + item.productImage),
        expression: "'/static/'+item.productImage"
      }],
      attrs: {
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "main"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.salePrice))]), _vm._v(" "), _c('div', {
      staticClass: "btn-area"
    }, [_c('a', {
      staticClass: "btn btn--m",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.addCart(item.productId)
        }
      }
    }, [_vm._v("加入购物车")])])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "view-more-normal",
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "20"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "src": require("./../assets/loading-spinning-bubbles.svg")
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlayFlag),
      expression: "overlayFlag"
    }],
    staticClass: "md-overlay",
    on: {
      "click": _vm.closePop
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "mdShow": _vm.mdShow
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('p', {
    slot: "message"
  }, [_vm._v("\n      请先登录，否则无法加入到购物车！\n    ")]), _vm._v(" "), _c('div', {
    slot: "btnGroup"
  }, [_c('a', {
    staticClass: "btn btn-m",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.mdShow = false
      }
    }
  }, [_vm._v("关闭")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "mdShow": _vm.mdShowCart
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('p', {
    slot: "message"
  }, [_c('span', [_vm._v("加入购车车成功！")])]), _vm._v(" "), _c('div', {
    slot: "btnGroup"
  }, [_c('a', {
    staticClass: "btn btn-m",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.mdShowCart = false
      }
    }
  }, [_vm._v("继续购物")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-m",
    attrs: {
      "href": "javascript:void(0)",
      "to": "/cart"
    }
  }, [_vm._v("查看购物车")])], 1)]), _vm._v(" "), _c('nav-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f469ddf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GoodsList.vue
// module id = 78
// module chunks = 0